import {
  SET_EXPORT_SETTINGS,
  SET_USER_SETTINGS,
  SET_APP_SETTINGS,
  SET_DARK_MODE,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../index').Settings} Settings
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * We're being flexible here because the definition lives elsewhere
 * and we don't want to override things.
 *
 * @type {Settings}
 */
const INITIAL_STATE = {
  exportSettings: null,
  appSettings: null,
  userSettings: null,
}

/**
 * @param {Settings} state
 * @param {PltrAction} action
 * @return {Settings}
 */
const settingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_EXPORT_SETTINGS: {
      return {
        ...state,
        exportSettings: action.exportSettings,
      }
    }
    case SET_USER_SETTINGS: {
      return {
        ...state,
        userSettings: action.userSettings,
      }
    }
    case SET_APP_SETTINGS: {
      return {
        ...state,
        appSettings: action.appSettings,
      }
    }
    case SET_DARK_MODE: {
      if (!state.appSettings?.user) {
        return state
      } else {
        return {
          ...state,
          appSettings: {
            ...state.appSettings,
            user: {
              ...state.appSettings?.user,
              dark: action.value,
            },
          },
        }
      }
    }
    default: {
      return state
    }
  }
}

export default settingsReducer
